import { useRating } from '@risksmart-app/components/src/hooks/useRating';

import { hasRange } from '@/utils/utils';

export const useComputedEffectiveness = ({
  design,
  performance,
}: {
  design: number;
  performance: number;
}) => {
  const overall = design * performance;

  const { options } = useRating('effectiveness');
  const overallOption = options.find(
    (band) =>
      hasRange(band) && overall >= band.range[0] && overall <= band.range[1]
  );

  // COI-991: undefined, not `Number(undefined)`. The bands are org-configurable
  // taxonomy and their ranges are declared independently of the
  // design/performance option lists, so an org that widens those lists without
  // widening the ranges leaves products with no matching band — design 5 x
  // performance 5 = 25 against default ranges that stop at 16 (4 x 4). The old
  // NaN was written straight into the form field, where Zod classifies NaN as
  // its own parsed type and reports "Required" on a field the user had just
  // filled in: the exact CUS-262 symptom, reintroduced by a second path. The
  // test here always described this as returning undefined.
  if (overallOption?.value === undefined) {
    return undefined;
  }

  return Number(overallOption.value);
};
